<div class="page-container" [class.demo]="isDemo">
  <div>
    <button class="leave-demo" *ngIf="isDemo" (click)="leaveDemo()">
      <i class="fas fa-arrow-left"></i>Demo verlassen
    </button>
    <span class="step-info">{{ 'learnset.create_steps.step_info' | translate:{current: step + 1, total: 3} }}</span>
    <h1>{{titles[step] | translate}}</h1>
  </div>

  <div>
    <app-create-prompt-step *ngIf="step === 0" [form]="promptForm!" (filesSelected)="onFileReceived($event)"></app-create-prompt-step>
    <app-create-structure-step *ngIf="step === 1" [topicStructure]="topicStructure" (topicStructureChange)="handleTopicStructureChange($event)"></app-create-structure-step>
    <app-create-result-step *ngIf="step === 2" [learnset]="learnset" [isDemo]="isDemo"></app-create-result-step>
  </div>

  <div class="footer" *ngIf="!(isDemo && step === 2)">
    <div class="buttons-container">
      <app-button *ngIf="step !== 0" [text]="'misc.back' | translate" (clickEvent)="prevStep()" [style]="'outlined'"></app-button>
      <app-button [text]="nextButtonTexts[step] | translate" (clickEvent)="nextStep()" [loading]="isLoading"></app-button>
    </div>
    <span *ngIf="errorMessage" class="error-message">{{errorMessage}}</span>
  </div>
</div>

